var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "rb-switch",
      class: { "rb-switch--on": _vm.turnOn, "rb-switch--off": !_vm.turnOn },
      attrs: { "data-element-id": _vm.dataElementId, disabled: _vm.disabled },
      on: { click: _vm.toggle },
    },
    [_c("div", { staticClass: "rb-switch__light" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }